import { z } from "zod";

import {
  appointmentStateDtoSchema,
  EAppointmentState,
} from "@/types/backoffice/dto/appointment/appointment-state-dto.ts";
import { appointmentTypeSchema } from "@/types/backoffice/dto/appointment/appointment-type-dto.ts";

export const appointmentManualBookingDtoSchema = z.object({
  comment: z.string(),
  id: z.number().nullable().default(null),
  isExternalAppointment: z.boolean().default(false),
  localEndDate: z.string(),
  localStartDate: z.string(),
  serviceProviderId: z.number(),
  slotState: z.string().nullable().default(null),
  state: appointmentStateDtoSchema.default(EAppointmentState.PLANNED),
  type: appointmentTypeSchema,
});

export type TAppointmentManualBookingDto = z.infer<typeof appointmentManualBookingDtoSchema>;
